import { render, staticRenderFns } from "./CardSelector.vue?vue&type=template&id=08d5c25f&scoped=true&"
import script from "./CardSelector.vue?vue&type=script&lang=ts&"
export * from "./CardSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CardSelector.vue?vue&type=style&index=0&id=08d5c25f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d5c25f",
  null
  
)

export default component.exports